import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ComponentReloadService } from '../../services/reload/component-reload.service';
import { ModalsService } from '../../services/modals/modals.service';
import { GlobalService } from '../../services/global/global.service';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-guest-document',
  templateUrl: './guest-document.component.html',
  styleUrls: ['./guest-document.component.scss'],
})
export class GuestDocumentComponent implements OnInit {
  @Output() formSubmitted = new EventEmitter<{ guest: any, documentType: any, file: any, fileName: any}>(); // Step 1: Add EventEmitter

  guest: any;
  documentType: string = '';
  otherDocumentType: string = '';
  attachedFileName: string | null = null;
  attachedFile: File | null = null;
  @ViewChild('documentResetBtn') documentResetBtn!: ElementRef;
  documentTypesArr: string[] = ['Aadhar Card', 'Pan Card', 'Passport', 'Visa', 'Others'];

  constructor(
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _globalService: GlobalService,
    private _popoverController: PopoverController
  ) {}

  ngOnInit() {
    this.guest.document?.forEach((doc: any) => {
      this.documentTypesArr = this.documentTypesArr.filter( item => item !== doc.documentCategory)
    });
  }

  closePopover(){
    this._popoverController.dismiss();
  }

  onDocumentTypeChange() {
    if (this.documentType !== 'Others') {
      this.otherDocumentType = '';
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    // Checking if image is more than 5MB
    if (file.size > 5 * 1024 * 1024) {
      this._globalService.customAlert("File size should be less than 5MB", "Invalid File Size");
      return;
    }
    if (file) {
      this.attachedFileName = file.name;
      this.attachedFile = file;
    }
  }

  openAttachedFile() {
    if (this.attachedFile) {
      const fileURL = URL.createObjectURL(this.attachedFile);
      this._modalPopupService.openImageModal(fileURL);
    }
  }

  resetAttachemenForm() {
    this.documentType = '';
    this.otherDocumentType = '';
    this.attachedFileName = null;
    this.attachedFile = null;
    this.documentResetBtn.nativeElement.click();
  }

  submitAttachmentForm() {
    if (this.documentType && this.attachedFile) {
      const doctype = this.documentType === 'Others' ? this.otherDocumentType : this.documentType;
      // Step 2: Emit form data along with guest
      this.formSubmitted.emit({
        guest: this.guest,
        documentType: doctype,
        file: this.attachedFile,
        fileName: this.attachedFileName,
      });
      this.closePopover();
    }
  }
}
